/* eslint-disable react/prop-types */
import React from 'react';
import styles from './CapsuleStat.less';

/**
 * CapsuleStat —— 彩色胶囊指标
 * ------------------------------------------------------------------
 * 对齐商家端「会员增长情况」顶部那两个大圆角胶囊：浅底 + 同色文字 +
 * 数值 + 右箭头（表示可点击跳转）。用 tone 区分语义：
 *   primary 浅蓝（新增 / 正向）   danger 浅红（流失 / 负向）
 *   success 浅绿   warning 浅橙   gray 中性
 * 与 StatCard 的区别：StatCard 是白底描边的通用指标卡，CapsuleStat 是
 * 带语义色的入口型指标，只放 1~2 个、不铺满一排。
 */
const CapsuleStat = (props) => {
  const {
    label,
    value,
    unit,
    tone = 'primary',
    onClick,
    suffix = true,
  } = props;
  const clickable = typeof onClick === 'function';

  return (
    <div
      className={`${styles.capsule} ${styles[tone] || ''} ${
        clickable ? styles.clickable : ''
      }`}
      onClick={clickable ? onClick : undefined}
      role={clickable ? 'button' : undefined}
    >
      <div className={styles.label}>{label}</div>
      <div className={styles.valueRow}>
        <span className={styles.value}>{value ?? '-'}</span>
        {unit && <span className={styles.unit}>{unit}</span>}
        {clickable && suffix && <span className={styles.arrow}>›</span>}
      </div>
    </div>
  );
};

export default CapsuleStat;
